import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'et-logout',
  templateUrl: './logout.component.html',
  styleUrls: []
})
export class LogoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
